import "./styles.scss";

import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import moment from "moment";
import { Line } from "react-chartjs-2";

import { useApp } from "context/app";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const mainClass = "dashboard-uptime";

const Uptime = ({ data, period }) => {
  const { theme } = useApp();
  const getThemeColor = (property) =>
    getComputedStyle(document.body).getPropertyValue(property).trim();

  const uptime_data = {
    labels: data?.items?.map((item) =>
      moment(item?.created_at).format(period === "month" ? "MMM D" : "hhA")
    ),
    datasets: [
      {
        data: data?.items?.map((item) => item?.response_time),
        fill: true,
        backgroundColor: ({ chart: { ctx, height } }) => {
          const backgroundColor = getThemeColor("--color-white");
          const accentColor = getThemeColor("--color-green-intense");
          const fillColor = `${accentColor}66`;
          const gradient = ctx.createLinearGradient(0, 0, 0, height);
          gradient.addColorStop(0, fillColor);
          gradient.addColorStop(0.75, backgroundColor);

          return gradient;
        },
        borderColor: () => getThemeColor("--color-green-intense"),
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: () => getThemeColor("--color-text"),
          callback: function (value) {
            return value + "ms";
          },
          font: {
            size: "12px",
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: () => getThemeColor("--color-text"),
          font: {
            size: "12px",
          },
        },
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className={mainClass}>
      <Line key={theme} data={uptime_data} options={options} />
    </div>
  );
};

export default Uptime;
